import { VesselAlertsModelBase, VesselAlert, AlertType } from './vessel-alerts-model';

export class VesselAlertsModelImpl extends VesselAlertsModelBase {

    getAlerts(imo: number) {
        return this._imoToAlerts.get(imo) || [];
    }

    getAlert(imo: number, alertId: string) {
        for (let alert of this.getAlerts(imo)) {
            if (alert.id === alertId) return alert;
        }

        return null;
    }

    addAlert(imo: number, alert: VesselAlert) {
        // Short-circuit if the alert already exists - we don't want to send an event in this case.
        // message alone isn't enough to detect "unchanged" for alert types with a static message
        // but a dynamic payload (e.g. ShallowSoundingsWarning's shallowSoundings, which varies with
        // the selected route) - without the payload check, switching to a different route with
        // different soundings would be silently ignored as a no-op.
        const existing = this.getAlert(imo, alert.id);
        if (existing && existing.message === alert.message &&
            JSON.stringify(existing.shallowSoundings) === JSON.stringify(alert.shallowSoundings)) return;

        // Ensure an existing alert with the same ID is replaced
        const alerts = this.getAlerts(imo).filter(existingAlert => { return existingAlert.id !== alert.id; });

        alerts.push(alert);
        this._imoToAlerts.set(imo, alerts);

        this.dispatchEvent(new CustomEvent(`alerts-changed`, {detail: {imo: imo, alerts}}));
    }

    removeAlert(imo: number, alertId: string) {
        const alerts = this.getAlerts(imo);
        const newAlerts = alerts.filter(existingAlert => { return existingAlert.id !== alertId; });
        if (alerts.length === newAlerts.length) return;

        this._imoToAlerts.set(imo, newAlerts);

        this.dispatchEvent(new CustomEvent(`alerts-changed`, {detail: {imo: imo, alerts: newAlerts}}));
    }

    clearAlerts(imo: number) {
        this._imoToAlerts.delete(imo);
        this.dispatchEvent(new CustomEvent(`alerts-changed`, {detail: {imo: imo, alerts: []}}));
    }
    removeAlertsByType(imo: number, alertId: AlertType) {
        const alerts = this.getAlerts(imo);
        const newAlerts = alerts.filter(existingAlert => { return existingAlert.type !== alertId; });
        if (alerts.length === newAlerts.length) return;

        this._imoToAlerts.set(imo, newAlerts);

        this.dispatchEvent(new CustomEvent(`alerts-changed`, {detail: {imo: imo, alerts: newAlerts}}));
    }

    private _imoToAlerts: Map<number,VesselAlert[]> = new Map();
}
